/**
 * Styles for wf-next-btn component (Shadow DOM)
 */

import { css } from 'lit';

import { sharedAnimations, buttonBaseStyles } from '../styles/shared.styles.js';

export const wfNextBtnStyles = [
  sharedAnimations,
  buttonBaseStyles,
  css`
    :host {
      display: block;
      width: 100%;
    }

    :host([hidden]) {
      display: none;
    }

    .wf-btn-next {
      width: 100%;
      flex: 1;
      background: var(--wf-btn-background, var(--wf-color-primary));
      border: 1px solid var(--wf-color-primary-border);
      color: white;
      position: relative;
    }

    .wf-btn-next:hover:not(:disabled) {
      filter: brightness(1.1);
    }

    .wf-btn-shortcut {
      display: inline-flex;
      align-items: center;
      gap: var(--wf-spacing-05);
    }

    .wf-loading {
      display: inline-block;
      width: var(--wf-spinner-size);
      height: var(--wf-spinner-size);
      border: 2px solid rgba(0, 0, 0, 0.1);
      border-radius: 50%;
      border-top-color: white;
      animation: wf-spin 0.8s linear infinite;
    }

    /* Inline button styles (for use inside wf-other) */
    :host([inline]) {
      display: inline-block;
      width: auto;
    }

    :host([inline]) .wf-btn {
      min-height: 16px;
      width: auto;
      padding-top: 8px;
      padding-bottom: 8px;
      padding-left: 12px;
      padding-right: 8px;
    }
  `,
];
